export default {
  tabTitle: 'Model Composer',
  composeModel: 'Componer modelo',
  intro: 'Construye un modelo con canales de tus modelos existentes.',
  search: 'Buscar',
  noModels: 'Aún no hay modelos compuestos',
  headerName: 'Nombre',
  headerCountry: 'País',
  headerQuality: 'Calidad',
  headerCreated: 'Creado',
  headerCreatedBy: 'Creado por',
  headerStatus: 'Estado',
  statusBuilding: 'En construcción',
  statusReady: 'Listo',
  viewReport: 'Ver reporte',
  printJson: 'Imprimir JSON en la consola',
  deleteModel: 'Eliminar modelo',
  deleteDialogTitle: '¿Eliminar modelo?',
  deleteDialogText: '{name} se eliminará. Podrás recuperarlo durante 7 días solicitándolo a un administrador.',
  deleteDialogTextBuilding: '{name} se eliminará de forma permanente.',
  cancel: 'Cancelar',
  delete: 'Eliminar',
  close: 'Cerrar',
  idCopied: 'ID copiado al portapapeles',
  snackDeleted: 'Modelo eliminado',
  snackErrorDeleting: 'Error al eliminar el modelo',
  relNow: 'ahora',
  relMinutes: '{n} min',
  relHours: '{n} h',
  relDays: '{n} d',
  relMonths: '{n} mes | {n} meses',
  relYears: '{n} año | {n} años'
}
